import * as React from 'react'
import Button from '../../../buttons/button'

import { IItem } from '../../../../../../typings/searchResults'
import CartIcon from '../../../../../shared/components/icons/cart'

import * as styles from './cartButtons.module.css'

interface IProps {
  item: IItem
  onAddToCart: React.EventHandler<any>
}

const CartButtons = ({ item, onAddToCart }: IProps) => {
  const { id, previews, ui } = item

  return (
    <React.Fragment>
      {previews.live_site && (
        <Button
          role="button"
          altPrimary
          large
          className={styles.previewButton}
          href={previews.live_site.url}
          target="_blank"
        >
          Preview
        </Button>
      )}
      <Button
        role="button"
        href={`/cart/configure_before_adding/${id}`}
        onClick={onAddToCart}
        active={ui.isInCart}
        className={styles.addToCart}
      >
        <CartIcon />
      </Button>
    </React.Fragment>
  )
}

export default CartButtons
